import { observer } from 'mobx-react-lite'
import { Fragment, useMemo } from 'react'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { EmptyState } from 'shared/ui'
import { useViewCallingContext } from 'pages/chatbot/pages/calling/pages/view/context'
import { getColumns } from './colums'
import styles from './styles.module.scss'

export const StatisticsTable = observer(() => {
  const { tableStore, itemsRows, isEmpty, search, setSearch, onOpenContactsDetails } =
    useViewCallingContext()

  const columns = useMemo(() => getColumns(onOpenContactsDetails), [onOpenContactsDetails])

  if (isEmpty) {
    return <EmptyState variant='default' text='No contacts found' noIcon />
  }
  return (
    <>
      <div className={styles.search}>
        <TableSearch value={search} onChange={setSearch} />
      </div>
      <div className={styles.wrapTable}>
        <Table
          ariaLabel={tableStore.config.key}
          store={tableStore}
          virtualization
          rows={itemsRows}
          columns={columns}
          emptyStateProps={{
            text: 'No contacts found',
          }}
        />
      </div>
    </>
  )
})
